import * as React from "react";
import {
    Box, Card, Chip, Container, IconButton, InputAdornment, MenuItem, TextField, Typography, Alert, Stack, Divider, Avatar, Grid, Dialog, DialogTitle, DialogContent, DialogActions, Button,
} from "@mui/material";
import ButtonComponent from "components/Button";
import {getPrice, isMarketPlace, checkProductInCart, isAuthorized, getURI} from "helpers/utils";


import {useState, useEffect} from "react";

import {H2, H5} from "components/CustomTypography";
import ImageAlbum from "components/elements/main/ImageAlbum";
import ShopHeaderOurCollection from "components/elements/user/shops/ShopHeaderOurCollection";
import ShopProductPopularSlider from "components/elements/user/products/ShopProductPopularSlider";
import ShopProductNewSlider from "components/elements/user/products/ShopProductNewSlider";
import ShopOffersSlider from "components/elements/user/offers/ShopOffersSlider";
import MockGeneralHeader from "components/elements/main/MockGeneralHeader";
import MockProductImage from "components/elements/main/MockProductImage";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import CircularProgress from "@mui/material/CircularProgress";
import {FlexBox} from "components/flex-box";
import SelectFieldComponent from "components/SelectField";
import ShopHeaderBack from "../../../main/ShopHeaderBack";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions/user/user-base.actions";
import {Notification} from "../../../../Atoms";
import TryOn from "../../../../icons/TryOn";
import Buy from "../../../../icons/Buy";


const ShopProductDetailModal = (props) => {

    const {
        selectedProduct, currency, onAddToWishlistClicked, onAddToCartClicked, messageShopClicked, onCancel, productdetail,
            isLoading, history, shopId, bootupInfo, userbootupInfo, cartItems, isCartLoading, cartAddingPid,
            generateVirtualTryOn, getAllTryOnProfileImages
    } = props;

    const [state, setState] = useState({});
    const [share, setShare] = useState(false);
    const [sizeState, setSizeState] = useState("");
    const [isGenerating, setIsGenerating] = useState(false);
    const [selectedProfileImageId, setSelectedProfileImageId] = useState(null);
    const [showProfileSelector, setShowProfileSelector] = useState(false);
    const [showRetryConfirmation, setShowRetryConfirmation] = useState(false);
    const [pendingTryOnData, setPendingTryOnData] = useState(null);

    const product = productdetail;

    const {
     created_at: createdAt, _id: _id, status, message
  } = selectedProduct || {};

    const { tryonProfileImage, virtualTryOnResult, tryonCredits, reqStatus, serviceError, tryonProfileImages } = userbootupInfo || {};

    const sendNotification = (type, { title, description = "" }) => {
        Notification[type]({
            message: title,
            description,
        });
    };

    useEffect(() => {
        // Load all profile images on mount
        isAuthorized() && getAllTryOnProfileImages();
    }, []);

    useEffect(() => {
        // Set default selected image when profile images are loaded
        if (tryonProfileImages && tryonProfileImages.length > 0 && !selectedProfileImageId) {
            setSelectedProfileImageId(tryonProfileImages[0]._id);
        }
    }, [tryonProfileImages]);

    useEffect(() => {
        if (serviceError) {
            // Check if the error is about existing try-on (DUPLICATE_TRYON)
            const errorMessage = serviceError.statusText || serviceError.message || serviceError;
            
            if (typeof errorMessage === 'string' && errorMessage.includes('already created a virtual try-on')) {
                // Show confirmation dialog instead of error notification
                setShowRetryConfirmation(true);
                setIsGenerating(false);
                return;
            }
            
            // For other errors, show notification
            const feedback = {
                title: serviceError,
                description: serviceError.statusText,
            };
            sendNotification("error", feedback);
        }
        if (reqStatus === "GENERATE_VIRTUAL_TRYON_SUCCESS") {
            setIsGenerating(false);
            history.push(getURI(process.env.REACT_APP_TYPE, "mytryons", ""));
        } else if (reqStatus === "GENERATE_VIRTUAL_TRYON_FAILURE") {
            setIsGenerating(false);
            history.push(getURI(process.env.REACT_APP_TYPE, "mytryons", ""));
        }
    }, [reqStatus, serviceError]);

    const handleTryOn = () => {

        if (!isAuthorized()) {
            history.push(getURI(process.env.REACT_APP_TYPE, "tryonprofile", ""))
            return;
        }

        if (!product) {
            alert("Product information not available");
            return;
        }

        if (!tryonProfileImages || tryonProfileImages.length === 0) {
            history.push(getURI(process.env.REACT_APP_TYPE, "tryonprofile", ""))
            return;
        }

        //if (tryonCredits?.balance <= 0) {
        //    history.push(getURI(process.env.REACT_APP_TYPE, "mybag", ""))
        //    return;
        //}

        // Proceed with try-on
        proceedWithTryOn();
    };

    const proceedWithTryOn = () => {
        // Store the try-on data in case we need to retry after confirmation
        setPendingTryOnData({
            productId: product.product_id,
            numberOfImages: 1,
            profileImageId: tryonProfileImages.length === 1 ? tryonProfileImages[0]._id : null
        });

        // If only one profile image, proceed directly
        if (tryonProfileImages.length === 1) {
            setIsGenerating(true);
            generateVirtualTryOn(product.product_id, tryonProfileImages[0]._id, 1);
            return;
        }

        // If multiple profile images, show selector
        setSelectedProfileImageId(tryonProfileImages[0]._id); // Set default selection
        setShowProfileSelector(true);
    };

    const handleConfirmTryOn = () => {
        if (!selectedProfileImageId) {
            return;
        }

        setShowProfileSelector(false);
        setIsGenerating(true);
        generateVirtualTryOn(product.product_id, selectedProfileImageId, 1);
    };

    const handleConfirmRetry = () => {
        setShowRetryConfirmation(false);
        
        if (!pendingTryOnData) {
            return;
        }
        
        // User confirmed they want to try on again
        // Call the API with force_duplicate flag
        setIsGenerating(true);
        
        const profileImageId = pendingTryOnData.profileImageId || selectedProfileImageId;
        
        // Call generateVirtualTryOn with force_duplicate flag
        generateVirtualTryOn(
            pendingTryOnData.productId, 
            profileImageId, 
            pendingTryOnData.numberOfImages,
            true // force_duplicate = true
        );
        
        setPendingTryOnData(null);
    };

    const handleCancelRetry = () => {
        userbootupInfo.serviceError = "";
        setShowRetryConfirmation(false);
        setPendingTryOnData(null);
        setIsGenerating(false);
    };

    const handleCancelProfileSelection = () => {
        setShowProfileSelector(false);
        setSelectedProfileImageId(null);
    };

    const handleShare = () => {
        setShare(!share);
    };

    const inputSizeOptions = product.size && product.size.map((item) => {
        return (
            <MenuItem value={item}>{item}</MenuItem>
        );
    });

    const handleSizeClick = (event) => {
        setSizeState(event.target.value);
    };

    const handleVisitPage = () => {
        history.push(getURI(process.env.REACT_APP_TYPE, "tryonprofile", ""))
    };

    const renderProductSize = () => (
        <SelectFieldComponent
            size="small"
            required
            options={inputSizeOptions}
            label="Size"
            value={sizeState}
            onChange={(event) => handleSizeClick(event)}
        />
    );


    const renderProductInformation = () => (
        <Box width="100%" >
            <Box mb={2} width="100%" display="flex" alignItems="center">
                <Box width="40%" >
                    <H2 fontSize={18} textAlign="left">
                        {getPrice(product, currency)}
                    </H2>
                </Box>
                <Box width="60%" display="flex" justifyContent="flex-end">
                    {
                        product.is_price_visible && parseFloat(product.price).toFixed(0) > 0 &&
                        (checkProductInCart(cartItems, product.product_id) ?
                                <ShoppingCartIcon color="primary" />
                                :
                                (isCartLoading && cartAddingPid === product.product_id ?
                                        <CircularProgress size="1rem"/>
                                        :
                                        <>
                                            <Box width="40%" display="flex" justifyContent="flex-end">
                                                {(product.size && product.size.length > 0) &&
                                                    renderProductSize()
                                                }
                                            </Box>
                                            <Box width="60%" display="flex" justifyContent="flex-end">
                                                <ButtonComponent
                                                    sx={{
                                                        mt: 2,
                                                        mb: 2,
                                                    }}
                                                    type="primary"
                                                    variant="contained"
                                                    name="Add to cart"
                                                    size="small"
                                                    onClick={() => onAddToCartClicked(product.product_id, shopId, !isMarketPlace(), sizeState)}
                                                />
                                            </Box>
                                        </>
                                )
                        )
                    }
                </Box>
            </Box>
            <Box width="100%" >
                <FlexBox width="100%" alignItems="left">
                    <Box width="50%">
                        <H5 fontSize={14} textAlign="left" >
                            {parseInt(product.fav) > 0 ?
                                <ButtonComponent
                                    sx={{
                                        mt: 2,
                                        mb: 2,
                                    }}
                                    disabled
                                    variant="contained"
                                    name="Liked!"
                                    size="small"
                                />
                                :
                                isCartLoading ? <CircularProgress size="1rem"/> :
                                    <>
                                        <ButtonComponent
                                            sx={{
                                                mt: 2,
                                                mb: 2,
                                            }}
                                            type="primary"
                                            variant="contained"
                                            name="Like!"
                                            size="small"
                                            onClick={() => onAddToWishlistClicked(product.product_id)}
                                        />
                                    </>
                            }
                        </H5>

                    </Box>
                </FlexBox>
            </Box>
        </Box>
    );
    const renderProductPhotos = () => (
        <Box display="flex" justifyContent="center" alignItems="center" width="100%">
            <ImageAlbum images={product.images}
                        onClickBottomRight={handleTryOn}
                        onClickBottomRightIcon={<TryOn />}
                        mainOnly={true} />
        </Box>
    );

    const renderProfileImageSelector = () => {
        if (!tryonProfileImages || tryonProfileImages.length <= 1) {
            return null;
        }

        return (
            <Dialog 
                open={showProfileSelector} 
                onClose={handleCancelProfileSelection}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Select Profile Image for Try-On
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ pt: 2 }}>
                        <Grid container spacing={2}>
                            {tryonProfileImages.map((profileImg) => (
                                <Grid item xs={4} sm={3} key={profileImg._id}>
                                    <Box
                                        onClick={() => setSelectedProfileImageId(profileImg._id)}
                                        sx={{
                                            cursor: 'pointer',
                                            position: 'relative',
                                            borderRadius: 1,
                                            overflow: 'hidden',
                                            border: selectedProfileImageId === profileImg._id ? '3px solid' : '2px solid',
                                            borderColor: selectedProfileImageId === profileImg._id ? 'primary.main' : 'grey.300',
                                            transition: 'all 0.2s',
                                            '&:hover': {
                                                borderColor: 'primary.light',
                                                transform: 'scale(1.05)',
                                            }
                                        }}
                                    >
                                        <Avatar
                                            variant="square"
                                            src={profileImg.cdn?.secure_url}
                                            alt="Profile option"
                                            sx={{
                                                width: '100%',
                                                height: 'auto',
                                                aspectRatio: '3/4',
                                            }}
                                        />
                                        {selectedProfileImageId === profileImg._id && (
                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    top: 4,
                                                    right: 4,
                                                    bgcolor: 'primary.main',
                                                    borderRadius: '50%',
                                                    width: 28,
                                                    height: 28,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                }}
                                            >
                                                ✓
                                            </Box>
                                        )}
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelProfileSelection} color="inherit">
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleConfirmTryOn} 
                        variant="contained" 
                        color="primary"
                        disabled={!selectedProfileImageId}
                    >
                        Try On with Selected Image
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };

    const renderRetryConfirmationDialog = () => {
        return (
            <Dialog
                open={showRetryConfirmation}
                onClose={handleCancelRetry}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    Try On Again?
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                        You've already created a virtual try-on for this product.
                    </Typography>
                    <Alert severity="info" sx={{ mt: 2 }}>
                        Creating a new try-on will use additional credits. Would you like to continue?
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelRetry} color="inherit">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleConfirmRetry}
                        variant="contained"
                        color="primary"
                    >
                        Yes, Try On Again
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };


    const renderProductShopMoreInfo = () => (
        <Box>
            <ShopHeaderOurCollection />
            <ShopProductPopularSlider 
                shopId={isMarketPlace() ? shopId : bootupInfo.appState.subdomain_shopId} 
                isInModal={true}
                onProductClick={onCancel}
            />
            <ShopProductNewSlider 
                shopId={shopId} 
                isInModal={true}
                onProductClick={onCancel}
            />
            {/*<ShopOffersSlider shopId={shopId} />*/}
        </Box>
    );

    const renderVirtualTryOn = () => {

        return (
            <Box sx={{ mt: 3 }}>
                <Divider sx={{ mb: 2 }} />
                <Stack spacing={2}>
                    {tryonCredits && (
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <H5 fontSize={14}>Try-On Credits:</H5>
                            <H5 fontSize={16} color="primary"><b>{tryonCredits.balance ? tryonCredits.balance : "0 (Available again in 24Hrs)"}</b></H5>
                        </Box>
                    )}

                    {!tryonProfileImage && (
                        <Alert severity="info">
                            Upload a profile image to use virtual try-on
                                                <ButtonComponent
                                                    type="primary"
                                                    variant="contained"
                                                    size="small"
                                                     name="Upload Profile Image"
                                                    onClick={handleVisitPage}  />
                        </Alert>
                    )}

                    {virtualTryOnResult && virtualTryOnResult.generated_images && virtualTryOnResult.generated_images.length > 0 && (
                        <Box>
                            <H5 fontSize={14} sx={{ mb: 2 }}>Try-On Result:</H5>
                            {virtualTryOnResult.generated_images.map((img, index) => (
                                <Box key={index} sx={{ mb: 2 }}>
                                    <img
                                        src={img.cdn?.secure_url || img.url}
                                        alt={`Try-on result ${index + 1}`}
                                        style={{ width: '100%', borderRadius: '8px' }}
                                    />
                                </Box>
                            ))}
                        </Box>
                    )}
                </Stack>
            </Box>
        );
    };

    return (
        <Container>
            <Container maxWidth="md">
                {isLoading && <MockProductImage />}
                {!isLoading && renderProductPhotos()}
                {renderProfileImageSelector()}
                {renderRetryConfirmationDialog()}
                {/* !isLoading && product && isAuthorized() &&  renderVirtualTryOn() */}

                {!isLoading && product && renderProductInformation()}
                {!isLoading && renderProductShopMoreInfo()}
            </Container>
        </Container>
    );
};

// Mapping Props and State
const shopProductDetailModal = connect(
    ({ userbootupInfo }) => ({
        reqStatus: userbootupInfo.reqStatus,
        isLoading: userbootupInfo.isLoading,
        serviceError: userbootupInfo.serviceError,
        tryonCredits: userbootupInfo.tryonCredits,
        tryonProfileImages: userbootupInfo.tryonProfileImages,
    }),
    (dispatch) =>
        bindActionCreators(
            {...Actions}, dispatch)
)(ShopProductDetailModal);

export { shopProductDetailModal as default };
